import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";
import { Row, Col } from "react-bootstrap";
import { orderBy, isEmpty } from "lodash";
import DropdownSearch from "../common/DropdownSearch";

const initislState = {
  name: "",
  description: "",
  department: "",
  status: true
};

const DepartmentCategoryForm = ({
  adding,
  departmentCategory,
  onSave,
  onCancel,
  departments
}) => {
  const [isValidForm, setIsValidForm] = useState(false);
  const [state, setState] = useState(initislState);

  useEffect(() => {
    if (!isEmpty(departmentCategory)) {
      setState({
        ...departmentCategory,
        department: departmentCategory.department._id
      });
    }
  }, [departmentCategory]);

  let form = useRef();

  const handleAdd = (values) => {
    setState(initislState);
    form.reset();
    onSave(values);
  };

  const handleEdit = (values) => {
    values.id = departmentCategory._id;
    form.reset();
    setState(initislState);
    onSave(values);
  };

  const handleChange = (name, { value }) => {
    setState((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Formsy
      ref={(ref) => (form = ref)}
      className="vertical form"
      onValidSubmit={adding ? handleAdd : handleEdit}
      onValid={() => setIsValidForm(true)}
      onInvalid={() => setIsValidForm(false)}
    >
      <Row>
        <Col md={3}>
          <Input
            required
            name="name"
            label="Name"
            placeholder="Name"
            value={state.name}
            validations={{ maxLength: 50 }}
            validationErrors={{
              maxLength: "You can not type in more than 50 characters"
            }}
          />
        </Col>
        <Col md={3}>
          <Input
            required
            name="description"
            label="Description"
            placeholder="Description"
            value={state.description}
            validations={{ maxLength: 150 }}
            validationErrors={{
              maxLength: "You can not type in more than 150 characters"
            }}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            required
            name="department"
            label="Department"
            onChange={handleChange}
            value={state.department}
            data={orderBy(
              [
                ...departments.map((dept) => ({
                  value: dept._id,
                  label: dept.description
                }))
              ],
              "label"
            )}
          />
        </Col>
        <Col md={3} xs={12}>
          <Checkbox
            formNoValidate
            name="status"
            valueLabel="Active"
            value={state.status}
          />
        </Col>
        <Col md={12} className="footer">
          <button
            type="button"
            style={!adding ? { display: "inline" } : { display: "none" }}
            className="btn  btn-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <input
            className="btn btn-success"
            type="submit"
            disabled={!isValidForm}
            value="Save"
          />
        </Col>
      </Row>
    </Formsy>
  );
};
DepartmentCategoryForm.propTypes = {
  adding: PropTypes.bool,
  departmentCategory: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  departments: PropTypes.array
};

DepartmentCategoryForm.defaultProps = {
  departments: []
};

export default DepartmentCategoryForm;
